export enum AppModule {
  Dashboard = 'Dashboard',
  Messages = 'Message',
  Broadcast = 'Broadcast',
  Profile = 'Profile',
  Task = 'Task',
  Notifications = 'Notifications',
  /* Start: From Database */

  Patient = 'Patient',
  Practitioner = 'Practitioner',
  ActivePatient = 'ActivePatient',
  VisitNotes = 'VisitNotes',
  Prescriptions = 'Prescriptions',
  InvestigationOrders = 'InvestigationOrders',
  InvestigationResults = 'InvestigationResults',
  Referrals = 'Referrals',
  PatientDiagnosis = 'PatientDiagnosis',
  Calendar = 'Calendar',
  Invoice = 'Invoice',
  Professionals = 'Professionals',
  Reports = 'Reports',
  Settings = 'Settings',
  Ratings = 'Ratings',
  Admin = 'Admin',
  Master = 'Master',
  Templates = 'Templates',
  RequestedReschedule = 'RequestedReschedule',
  PatientEducation = 'PatientEducation',
  /* End: From Database */
}
